import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { Button, IconButton, Text12M } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { MenuSection } from '../MenuSection';

export const MenuHeader = styled.div`
  position: relative;
  padding: 0 12px;
  box-sizing: border-box;
  height: ${(props) => props.theme.layout.headerHeight}px;
`;

export const MenuHeaderInner = styled.div`
  display: flex;
  align-items: center;
  height: ${(props) => props.theme.layout.headerHeight}px;
  padding: 0 12px;
  border-bottom: 1px solid ${Colors.DarkerMiddle};
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(50%, -50%);
`;

export const CategoryTitle = styled(Text12M)`
  color: ${ct({ Dark: Colors.White, Light: Colors.White })};
`;

export const AddDashboardButton = styled(Button)`
  padding-left: 12px;
  align-self: flex-start;
`;

export const MenuContent = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-flow: column;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const MenuSectionStyled = styled(MenuSection)`
  display: flex;
  max-height: 100%;
  margin-top: 0;
  padding-top: 16px;
  flex-flow: column;
`;

export const MenuStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-flow: column;
  width: ${(props) => props.theme.layout.dashboardsMenuWidth}px;
  height: 100vh;
  background: ${ct({ Dark: Colors.Darkest, Light: Colors.Darkest })};
  transition: transform ease-in-out 0.3s;
  transform: translateX(-10%);
`;

export const MenuWrapper = styled.div`
  position: relative;
  width: 0;
  transition: width ease-in-out 0.3s;
  z-index: 44;

  &[aria-expanded='true'] {
    width: ${(props) => props.theme.layout.dashboardsMenuWidth}px;

    & ${MenuStyled} {
      transform: translateX(0);
    }
  }
`;

export const MenuBottomContainer = styled(Box)`
  padding: 16px 12px 24px 12px;
  color: ${ct({ Dark: Colors.Grey, Light: Colors.Grey })};
`;
